import { OperandType, OperatorsType } from '@/interface/numberSysytem';
import { StoryNumberListData } from '@/pages/numberSystem/setNumberTable/table';

import { CardData } from './numberSystem/cards';

export const getNumberDesc = (data: CardData[], variableNumList: StoryNumberListData[]) => {
  // 运算符映射表
  const OPERATOR_MAP: Record<OperatorsType, string> = {
    [OperatorsType.ADD]: '+',
    [OperatorsType.SUB]: '-',
    [OperatorsType.MULTI]: '*',
    [OperatorsType.DIVIDE]: '÷',
    [OperatorsType.EQ]: '=',
    [OperatorsType.GT]: '>',
    [OperatorsType.LT]: '<',
    [OperatorsType.LTE]: '≤',
    [OperatorsType.GTE]: '≥',
    [OperatorsType.AND]: '且',
    [OperatorsType.OR]: '或',
    [OperatorsType.DEFAULT]: '',
  };

  // 操作数类型映射表
  const OPERAND_TYPE_MAP: Record<OperandType, string> = {
    [OperandType.VARIABLE]: '变量',
    [OperandType.CONSTANT]: '数值',
    [OperandType.DEFAULT]: '',
  };

  const result: JSX.Element[] = [<></>];
  data?.forEach((item, i) => {
    const expression1: string[] = [];
    const expression2: string[] = [];
    expression1.push(OPERATOR_MAP[item?.logicalOp]);
    item?.opGroup.forEach((opG, j) => {
      const text1 = j === 0 ? '' : OPERATOR_MAP[opG?.op || OperatorsType.DEFAULT] || '()';
      const text2 = OPERAND_TYPE_MAP[opG?.operand?.operandType];
      let text3 = '-';
      if (opG?.operand?.operandType === OperandType.VARIABLE) {
        text3 = `(${variableNumList?.find(variableNum => variableNum?.id === opG?.operand?.variableNumId)?.combineName || ''})`;
      } else {
        text3 = `(${opG?.operand?.constantVal})`;
      }

      expression2.push(text1 + text2 + text3);
    });
    result.push((
      <span key={i}>
        {
          expression1?.[0] ? <span style={{ margin: '0 8px' }}>{expression1?.[0]}</span> : null
        }
        <span>{expression2?.join('')}</span>
      </span>
    ));
  });
  return result;
};
